import _ from "lodash";
import React, { useEffect, useRef } from "react";

import {FormTextInput} from "UIComponents/InputTextField";
import { Button } from "@toddle-edu/ds-web";

import classes from "./ForgotPassword.scss";

const ForgotPasswordScreen = React.memo(props => {
  const {
    updateInputField,
    data: { email } = {},
    onBackClick,
    onSendClick,
    checkEmailVerification,
    updateInpurRef,
    onEmailEnter,
    renderBackButtonComponent,
    customStyle: { headerStyleV2, subTextStyle } = {},
    renderTradeMarkText,
    isOrgWorkspaceLoginPage = false,
  } = props;

  const containerStyle = {
    paddingTop: isOrgWorkspaceLoginPage ? "13%" : "19.5%",
  };

  return (
    <div className={classes.container} style={containerStyle}>
      <div className={classes.contentContainer}>
        <div className={classes.headerContainer}>
          {renderBackButtonComponent({
            onClick: onBackClick,
            buttonText: "Go back",
          })}
          <div className={classes.titleContainer}>
            <div style={headerStyleV2}>{"Forgot Password?"}</div>
            <div style={subTextStyle}>
              {
                "Please enter your email address below and we’ll send a temporary password to this email"
              }
            </div>
          </div>
        </div>
        <div className={classes.inputContainer}>
          <FormTextInput
            dsVersion="2.0"
            size={"large"}
            textInputLabel={"Email*"}
            value={email}
            placeholder={"Enter your email"}
            name={"email"}
            updateInputField={updateInputField}
            customValidation={checkEmailVerification}
            ref={ref => updateInpurRef(email, ref)}
            error={"Enter email address"}
            onEnter={onEmailEnter}
            autoComplete={"off"}
            autoFocus={true}
          />
        </div>
        <div className={classes.bottomContainer}>
          <Button
            dsVersion="2.0"
            variant={"destructive"}
            size={"large"}
            onClick={onSendClick}
            isFullWidth={true}
          >
            Send temporary password
          </Button>
        </div>
      </div>

      <div>
        {renderTradeMarkText({
          align: "left",
        })}
      </div>
    </div>
  );
});

ForgotPasswordScreen.displayName = "ForgotPasswordScreen";

const ConfirmationScreen = React.memo(props => {
  const {
    onSignClick,
    renderTradeMarkText,
    isOrgWorkspaceLoginPage = false,
  } = props;

  const buttonRef = useRef(null);

  const handleKeyDown = event => {
    if (
      event.key === "Enter" &&
      buttonRef.current &&
      !buttonRef.current.disabled
    ) {
      buttonRef.current.click();
    }
  };

  const containerStyle = {
    paddingTop: isOrgWorkspaceLoginPage ? "13%" : "19.5%",
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className={classes.container} style={containerStyle}>
      <div>
        <div className={classes.confirmationHeaderText}>
          {`Your new password has been sent!`}
        </div>
        <div className={classes.confimationSubTextContainer}>
          <div className={classes.confirmationSubText}>
            {`We have sent a new password on the provided email address`}
          </div>
          <div
            className={classes.confirmationSubText1}
          >{`If you didn’t recieve the mail, please contact your administrator`}</div>
        </div>
        <div className={classes.bottomContainer}>
          <Button
            variant={"destructive"}
            size={"large"}
            onClick={onSignClick}
            ref={buttonRef}
          >
            {"Sign in"}
          </Button>
        </div>
      </div>
      <div>
        {renderTradeMarkText({
          align: "left",
        })}
      </div>
    </div>
  );
});

ConfirmationScreen.displayName = "ConfirmationScreen";

class ForgotPassword extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { isSent: false };
    this.inputRefs = {};
  }

  UNSAFE_componentWillMount = () => {
    const { resetScreen, loginData } = this.props;
    resetScreen("forgotPassword", { email: loginData.email });
  };

  isValid = () => {
    const refKeys = Object.keys(this.inputRefs);
    let errorCount = 0;
    _.forEach(refKeys, key => {
      if (this.inputRefs[key]) {
        errorCount += this.inputRefs[key].isValid();
      }
    });

    return errorCount;
  };

  onSendClick = async () => {
    const {
      sendForgotPassword,
      showErrorToast,
      updateInputField,
      data: { email } = {},
    } = this.props;

    await updateInputField({
      email: _.trim(email),
    });

    updateInputField(
      {
        email: _.trim(email),
      },
      "loginForm"
    );

    updateInputField(
      {
        email: _.trim(email),
      },
      "loginFormV3"
    );

    const errorCount = this.isValid();
    showErrorToast({ errorCount });
    if (errorCount > 0) {
      return;
    }

    sendForgotPassword({
      successCallBack: () => {
        this.setState({ isSent: true });
      },
    });
  };

  onBackClick = () => {
    const { goToBack, updateInputField } = this.props;

    updateInputField({ shouldSkipResetPasswordScreen: false }, "loginFormV3");
    goToBack();
  };

  updateInpurRef = (key, ref) => {
    this.inputRefs[key] = ref;
  };

  onEmailEnter = () => {
    this.onSendClick();
  };

  render() {
    const { isSent } = this.state;

    return !isSent ? (
      <ForgotPasswordScreen
        {...this.props}
        onBackClick={this.onBackClick}
        onSendClick={this.onSendClick}
        updateInpurRef={this.updateInpurRef}
        onEmailEnter={this.onEmailEnter}
      />
    ) : (
      <ConfirmationScreen {...this.props} onSignClick={this.onBackClick} />
    );
  }
}

export default ForgotPassword;
